module.exports = __webpack_public_path__ + "static/media/actionPanel.b220629b.png";